import React from "react";
import { Instruction } from "@atlaskit/pragmatic-drag-and-drop-hitbox/list-item";
import classNames from "classnames";
import styles from "./CustomDropIndicator.module.scss";

type Props = {
  instruction: Instruction;
  className?: string;
};

export const CustomDropIndicator = ({ instruction, className }: Props) => {
  const isReorder =
    instruction.operation === "reorder-before" ||
    instruction.operation === "reorder-after";

  return (
    <div
      className={classNames(
        {
          [styles.combine]: !isReorder && instruction.operation === "combine",
          [styles.reorder]: isReorder,
          [styles.top]: instruction.operation === "reorder-before",
          [styles.bottom]: instruction.operation === "reorder-after",
        },
        className,
      )}
    />
  );
};
